import { useState, useEffect, Fragment } from "react";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import FleetWebApi from "../Api/FleetWebApi";
import CompanionConnection from "../FleetManagement/CompanionConnection";

// default window - used only if a parent doesn't pass startDate/endDate.
const DEFAULT_START_DATE = new Date() - 12096e5; // now - 14 days
const DEFAULT_END_DATE = new Date();

function CompanionRadioInformation(props) {
  const [error, setError] = useState();
  const [measurementData, setMeasurementData] = useState();
  const [isLoading, setIsLoading] = useState();
  const startDate = props.startDate !== undefined ? props.startDate : DEFAULT_START_DATE;
  const endDate = props.endDate !== undefined ? props.endDate : DEFAULT_END_DATE;
  const getByArrivalDate = props.getByArrivalDate !== undefined ? props.getByArrivalDate : true;
  const refreshCount = props.refreshCount !== undefined ? props.refreshCount : 0;

  useEffect(() => {
    let element = document.getElementById("chart");
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
    if (measurementData && measurementData !== null) {
      try {
        window.Bokeh.embed.embed_item(measurementData, "chart");
      } catch (error) {
        console.log(error);
        setError(error);
      }
    }
  }, [measurementData]);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setMeasurementData(null);

    FleetWebApi.getCompanionRadioDataFromCoreId(
      props.coreId,
      startDate,
      endDate,
      getByArrivalDate ? "arrivalDate" : "timestamp",
      props.productType
    )
      .then((resp) => {
        if (resp.error) {
          if (isMounted) {
            console.log(resp.error);
            setError(resp.error);
            setIsLoading(false);
          }
        } else {
          if (isMounted) {
            setMeasurementData(resp);
            setError(null);
            setIsLoading(false);
          }
        }
      })
      .catch((error) => {
        if (isMounted) {
          console.log(error);
          setError(error.message);
          setIsLoading(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [props.coreId, startDate, endDate, getByArrivalDate, refreshCount]);

  return (
    <Fragment>
      <CompanionConnection
        coreId={props.coreId}
        startDate={startDate}
        endDate={endDate}
      />

      <Container maxWidth="lg">
        <h2>Lora Radio Data</h2>
      </Container>
      <Container maxWidth="lg" className="full-height">
        {isLoading && <CircularProgress />}
        {error && <p>Error Loading Data: {error}</p>}
        <div id="chart" className="bk-root"></div>
      </Container>
    </Fragment>
  );
}

export default CompanionRadioInformation;
